import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Generates an SEO-friendly slug from a product name.
 * Example: "Apple MacBook Pro M1" -> "apple-macbook-pro-m1"
 */
export const generateSlug = (name: string): string => {
  if (!name) return "";
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-") // Replace non-alphanumeric characters with dashes
    .replace(/(^-|-$)+/g, ""); // Remove trailing/leading dashes
};

/**
 * Generates an SEO-friendly URL for a product using ONLY its slugified name.
 * Example: /product/apple-macbook-pro-m1
 */
export const generateProductUrl = (id: string, name: string) => {
  if (!name || !id) return `/product/${id}`;
  return `/product/${generateSlug(name)}`;
};
